import React, { useState, useEffect, Fragment } from "react";
import iconWrapSvg from "../../images/newHome/icon_wrap.png"
import iconExpandSvg from "../../images/newHome/icon_expand.png"
import SectionTitle from "./SectionTitle";

function FAQSection() {

    const faqs = [
        {
            question: "What is Telcron?",
            answer:
                "Telcron is a compliance testing and certification platform that helps businesses meet industry regulations.",
        },
        {
            question: "How can I book a lab for testing?",
            answer:
                "You can book a lab through our online portal by selecting your desired date, location, and test type.",
        },
        {
            question: "What industries do you serve?",
            answer:
                "We serve industries like electronics, medical devices, automotive, telecommunications, and more.",
        },
        {
            question: "How do I track my compliance process?",
            answer:
                "Log in to your dashboard to view real-time updates and progress on your compliance certification journey.",
        },
    ];

    const [openIndex, setOpenIndex] = useState(0); // First item open by default

    const toggleFAQ = (index: any) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <Fragment>
            <div className="container lg:px-20 lg:pt-24 lg:pb-16 px-4 pt-4 pb-5">
                <div className="text-white text-center p-4">
                    <SectionTitle
                        size="font-inter lg:text-[44px] text-[32px]"
                        weight="font-bold"
                        color="text-titleColor"
                        className="mb-[18px] leading-[38px]"
                    >
                        Frequently asked questions
                    </SectionTitle>
                    <p className="lg:text-lg text-base text-textColor">Everything you need to know about the product and billing.</p>
                </div>

                {/* FAQ */}
                <div className="max-w-3xl mx-auto space-y-4 lg:pt-12 pt-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`rounded-lg p-4 lg:p-8 transition-all duration-300 ${openIndex === index ? "bg-lightGrayBgColor" : "bg-white"}`}
                        >
                            <div className="grid grid-cols-[auto,1fr] gap-4 items-start">
                                {/* Left: Icon button */}
                                <button onClick={() => toggleFAQ(index)} className="mt-1 focus:outline-none">
                                    <img
                                        src={openIndex === index ? iconWrapSvg : iconExpandSvg}
                                        alt="Toggle icon"
                                        className="w-5 h-5"
                                    />
                                </button>

                                {/* Right: Question and Answer */}
                                <div>
                                    <button
                                        onClick={() => toggleFAQ(index)}
                                        className="text-left w-full focus:outline-none"
                                    >
                                        <span className="text-lg font-medium">{faq.question}</span>
                                    </button>

                                    {openIndex === index && (
                                        <div className="mt-2 text-gray-600 text-base">
                                            {faq.answer}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}

export default FAQSection;